<template>

    <hr-contracts-index></hr-contracts-index>

</template>

<script>

import HrContractsIndex from "../../components/HR/Contracts/Index";

export default {

    components: {
        HrContractsIndex,
    },

    metaInfo: {
        title:'Contracts',
    },

    name:'HrContracts',

}

</script>
